// extracted by mini-css-extract-plugin
export var angle = "reviews-module--angle--cIw36";
export var angle_rotate = "reviews-module--angle_rotate--7a7Oj";
export var btn = "reviews-module--btn--tmMw4";
export var btn_groupe = "reviews-module--btn_groupe--SPSyr";
export var reviews_container = "reviews-module--reviews_container--Vk-LO";
export var reviews_loader_container = "reviews-module--reviews_loader_container--3ojA-";
export var section = "reviews-module--section--gs3RC";
export var title = "reviews-module--title--WCStm";
export var title_container = "reviews-module--title_container--36i7Y";